if (!customElements.get('card-quick-add')) {
  customElements.define(
    'card-quick-add',
    class CardQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.toggleButton = this.querySelector('.card-quick-add__toggle');
        this.popoverEl = this.querySelector('.card-quick-add__popover');
        this.closeButton = this.querySelector('.card-quick-add__close');
        this.form = this.querySelector('.card-quick-add__form');
        this.variantInput = this.querySelector('.card-quick-add__variant-input');
        this.hasVariants = this.dataset.hasVariants === 'true';
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.toggleButton.addEventListener('click', this.onToggleClick.bind(this));

        if (this.popoverEl) {
          this.closeButton.addEventListener('click', () => this.closePopover());
          this.popoverEl.addEventListener('click', this.onVariantClick.bind(this));
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
        }
      }

      onToggleClick(event) {
        event.preventDefault();
        if (this.toggleButton.disabled) return;

        if (this.hasVariants) {
          if (this.popoverEl.hasAttribute('hidden')) {
            this.openPopover();
          } else {
            this.closePopover();
          }
        } else {
          this.addToCart(this.variantInput.value);
        }
      }

      openPopover() {
        this.popoverEl.removeAttribute('hidden');
        this.toggleButton.setAttribute('aria-expanded', 'true');
        // Defer to next tick to avoid catching the opening click
        setTimeout(() => {
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
        }, 0);
      }

      closePopover() {
        this.popoverEl.setAttribute('hidden', '');
        this.toggleButton.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.closePopover();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.closePopover();
          this.toggleButton.focus();
        }
      }

      onVariantClick(event) {
        const button = event.target.closest('.card-quick-add__variant');
        if (!button || button.disabled) return;
        const variantId = button.dataset.variantId;
        this.variantInput.value = variantId;
        this.closePopover();
        this.addToCart(variantId);
      }

      addToCart(variantId) {
        if (this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');
        this.toggleButton.setAttribute('aria-disabled', 'true');

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.set('id', variantId);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(this.toggleButton);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'card-quick-add',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.flashError();
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'card-quick-add',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (this.cart) {
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }

            this.flashSuccess();
          })
          .catch(err => {
            console.error(err);
            this.flashError();
          })
          .finally(() => {
            this.classList.remove('is-loading');
            this.toggleButton.removeAttribute('aria-disabled');
          });
      }

      flashSuccess() {
        this.classList.add('is-success');
        setTimeout(() => this.classList.remove('is-success'), 1200);
      }

      flashError() {
        this.toggleButton.animate(
          [
            { transform: 'translateX(0)' },
            { transform: 'translateX(-4px)' },
            { transform: 'translateX(4px)' },
            { transform: 'translateX(0)' },
          ],
          { duration: 300 }
        );
      }
    }
  );
}
